var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLettermark = function SvgLettermark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 93",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.08 55.222l10.724-22.678 11.77 22.678H26.08zm14.421-28.655H37.79L15.48 73.71h1.787l7.95-16.762h24.219l8.689 16.762h6.84L40.501 26.567z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 91.889V40.802C1 19.85 17.207 2.102 38.16 1.054c22.616-1.17 41.35 16.824 41.35 39.132v51.703H1z",
    stroke: "#000",
    strokeMiterlimit: 10
  })));
};

export default SvgLettermark;